import React from 'react';

function formatProductLabel(key) {
  if (!key || key === 'unknown') return 'Unknown';
  return key;
}

export function ProductSummaryStats({ stats, chartView, getProductColor }) {
  const {
    totalRevenue,
    totalCount,
    byPlan,
    totalDiscount,
    amountMode,
    paidCount,
    promo100Count,
    freeCount
  } = stats || {};

  const revenueLabel = amountMode === 'full' ? 'Total (Pre-Discount)' : 'Total Revenue';

  return (
    <div className="stripe-summary-stats">
      <div className="stripe-summary-row">
        <div className="stripe-summary-card">
          <div className="stripe-summary-label">{revenueLabel}</div>
          <div className="stripe-summary-value stripe-summary-revenue">
            ${typeof totalRevenue === 'number' ? totalRevenue.toFixed(2) : '0.00'}
          </div>
        </div>
        <div className="stripe-summary-card">
          <div className="stripe-summary-label">Total Purchases</div>
          <div className="stripe-summary-value">{totalCount ?? 0}</div>
        </div>
        <div className="stripe-summary-card">
          <div className="stripe-summary-label">Paid</div>
          <div className="stripe-summary-value">{paidCount ?? 0}</div>
        </div>
        <div className="stripe-summary-card">
          <div className="stripe-summary-label">100% Promo</div>
          <div className="stripe-summary-value stripe-summary-pending">{promo100Count ?? 0}</div>
        </div>
        <div className="stripe-summary-card">
          <div className="stripe-summary-label">Free</div>
          <div className="stripe-summary-value">{freeCount ?? 0}</div>
        </div>
        {typeof totalDiscount === 'number' && totalDiscount > 0 && (
          <div className="stripe-summary-card">
            <div className="stripe-summary-label">Total Discounts</div>
            <div className="stripe-summary-value stripe-summary-discount">
              ${totalDiscount.toFixed(2)}
            </div>
          </div>
        )}
      </div>
      {byPlan && Object.keys(byPlan).length > 0 && (
        <div className="stripe-summary-by-plan">
          <div className="stripe-summary-label">Revenue by Product</div>
          <div className="stripe-summary-plan-grid">
            {Object.entries(byPlan).map(([productKey, amount]) => (
              <div key={productKey} className="stripe-summary-plan-item">
                <span
                  className="stripe-summary-plan-dot"
                  style={{ backgroundColor: getProductColor(productKey) }}
                />
                <span className="stripe-summary-plan-name">
                  {formatProductLabel(productKey)}
                </span>
                <span className="stripe-summary-plan-amount">${amount.toFixed(2)}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
